/**
 * DashboardCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Dashboard} from '@/model/resource/Dashboard'

@HttpExclude()
export class DashboardCollection extends PageCollection<Dashboard> {
  annually = false

  constructor() {
    super(Dashboard)
  }

  queryAsPage() {
    if (this.annually) {
      return this.listFaturamentoAnnually()
    }
    return this.listFaturamento()
  }

  async listFaturamento() {
    return await Request.get(`/admin/dashboard`, {params: this.params})
      .name('listDashboard')
      .as(this)
      .getResponse()
  }

  async listFaturamentoAnnually() {
    return await Request.get(`/admin/dashboard/annually`, {params: this.params})
      .name('listDashboard')
      .as(this)
      .getResponse()
  }

  async listCsvDashboard() {
    return await Request.get(`/admin/dashboard/csv`, {params: this.params})
      .name('listCsvDashboard')
      .as(this)
      .getResponse()
  }
}
